import { isProd } from './Utils';

export const TOKEN_SESSION_KEY = 'TOKEN';

export const LATITUDE = 'latitude';

export const LONGITUDE = 'longitude';

export const APP_VERSION = 'appversion';

export const LOCALE = 'locale';

export const MODULE_DEEPLINKS = {
	SWIPE: 'bharatpe://dynamic?key=bharat-swipe-v2',
	SWIPE_WEB: 'https://bharat-swipe-v2.bharatpe.in',
	PAYMENT_DASHBOARD: 'bharatpe://homev2/payments',
	BANKING_DASHBOARD: 'bharatpe://homev2/banking',
	SPEAKER: 'bharatpe://dynamic?key=bharatpe-speaker-v2',
	CHAT_SUPPORT: 'bharatpe://dynamic?key=freshbot_lending-prod',
};

/** FRM host key from `REACT_APP_FRM_FE_DEEPLINK` (e.g. `frm-fe-qa` in `.env.qa`, `frm-fe` in `.env`). */
export const getFrmChargebackListDeeplink = (sourceProduct?: string): string => {
	const base = `bharatpe://dynamic?key=${process.env.REACT_APP_FRM_FE_DEEPLINK ?? 'frm-fe'}&pageRoute=chargeback`;
	return sourceProduct ? `${base}&sourceProduct=${encodeURIComponent(sourceProduct)}` : base;
};

/** FRM dispute details; `paymentTxnId` is appended when the WebView URL includes it (same as legacy upload-chargeback id). */
export const getFrmDisputeDetailsDeeplink = (paymentTxnId?: string, sourceProduct?: string): string => {
	let url = `bharatpe://dynamic?key=${process.env.REACT_APP_FRM_FE_DEEPLINK ?? 'frm-fe'}&pageRoute=dispute-details`;
	if (paymentTxnId) url += `&paymentTxnId=${encodeURIComponent(paymentTxnId)}`;
	if (sourceProduct) url += `&sourceProduct=${encodeURIComponent(sourceProduct)}`;
	return url;
};

export const LANGUAGE = 'swipeLanguage';

export const blacklistMerchants = [
	35764063, 36826476, 36178235, 262427, 35415498, 27147004, 8155148, 36250656, 36243803, 36937714, 36875630, 36949311,
	25683527, 28208240,
];

export const IOS_JUSPAY_APP_VERSIONS = {
	BHARATPE: '254',
};

export const ANDROID_JUSPAY_APP_VERSIONS = {
	BHARATPE: '325',
};

export const RETURN_LIST_DATA = [
	{
		id: 1,
		title: 'No Longer Needed',
		label: 'NO_LONGER_NEEDED',
		eventKeyword: 'no_longer_needed',
	},
	{
		id: 2,
		title: 'Network Issues',
		label: 'NETWORK_ISSUES',
		eventKeyword: 'network_issues',
	},
	{
		id: 3,
		title: 'Low Battery Backup',
		label: 'LOW_BATTERY_BACKUP',
		eventKeyword: 'low_battery_backup',
	},
	{
		id: 4,
		title: 'High MDR',
		label: 'HIGH_MDR',
		eventKeyword: 'high_mdr',
	},
	{
		id: 5,
		title: 'Settlement Issues',
		label: 'SETTLEMENT_ISSUES',
		eventKeyword: 'settlement_issues',
	},
	{
		id: 6,
		title: 'Service Issues Unresolved',
		label: 'SERVICE_ISSUES_UNRESOLVED',
		eventKeyword: 'service_issues_unresolved',
	},
	{
		id: 7,
		title: 'Wrong Information provided while selling',
		label: 'WRONG_INFO_PROVIDED_WHILE_SELLING',
		eventKeyword: 'wrong_information_provided_while_selling',
	},
	{
		id: 8,
		title: 'Got better deal from competitor',
		label: 'GOT_BETTER_DEAL',
		eventKeyword: 'got_better_deal_from_competitor',
	},
];

export const ANDRDOID_DEVICE_ALLOWED_MERCHANT_LIST = [
	767075, 37921228, 27487326, 41891209, 28469681, 41907213, 9044364, 7926699, 41909854, 4542182, 41914210, 41684717,
	41918792, 1881663, 41919424, 34386620, 3912527, 611864,
];

export const MSG_CONSTANT = {
	FAILED_TO_SHARE: 'Sharing failed, Please try again',
};

export const COUPON_REGEX = new RegExp('[^A-Za-z0-9]+');

export const LAUNCH_LAB_EXP_ID_LIST = {
	prod: { NEW_ONBOARDING: 74, VICINITY_CHECK: 113 },
	qa: { NEW_ONBOARDING: 107, VICINITY_CHECK: 150 },
};

export const LAUNCH_LAB_EXP_IDS = isProd() ? LAUNCH_LAB_EXP_ID_LIST.prod : LAUNCH_LAB_EXP_ID_LIST.qa;

export const KYC_STATUS = {
	APPROVED: 'APPROVED',
	PENDING: 'PENDING',
	REJECTED: 'REJECTED',
};
